import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  sessionsReportFilterSchema,
  sessionsReportFilterDefaults,
  type SessionsReportFilterValues,
} from '../schemas/sessions-report-schemas';

/**
 * Form wiring for the Sessions Report filters strip.
 * SRP: only knows about the form state + validation, not about the API.
 */
const useSessionsReportFilters = (overrides?: Partial<SessionsReportFilterValues>) => {
  const form = useForm<SessionsReportFilterValues>({
    resolver: zodResolver(sessionsReportFilterSchema),
    defaultValues: { ...sessionsReportFilterDefaults, ...overrides },
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
  });

  return form;
};

export default useSessionsReportFilters;
